import { Component, OnInit, Input } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant élément signalétique
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-element-signaletique',
  templateUrl: './element-signaletique.component.html',
  styleUrls: ['./element-signaletique.component.scss']
})
export class ElementSignaletiqueComponent extends BaseComponent implements OnInit {
    @Input() type: string;
    @Input() description: string;

    /**
     * Constructeur
     */
    constructor() { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }
}
